import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1638 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1638 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M1638.4 0H0l819.2 1024 819.2-1024z\" p-id=\"2285\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol